import React from 'react';
import { Loader } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../utils/localization';
import { invertedMessages } from '../../utils/messages';

import './DashboardLoader.css';

interface DashboardLoaderProps {
  testId: string;
}

DashboardLoader.default = {
  testId: '',
};

function DashboardLoader({ testId }: DashboardLoaderProps) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <section className='Ispm-DashboardLoader' data-testid={testId}>
      <Loader
        kind='loop'
        format='main'
        color='brand'
        className='Ispm-DashboardLoader-loader'
      />
      <span className='Ispm-DashboardLoader-text'>
        {l('Loading Dashboard')}
      </span>
      <span className='Ispm-DashboardLoader-caption'>
        {l('This may take several seconds')}
      </span>
    </section>
  );
}

export default DashboardLoader;
